import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@shared/auth/auth-guard';


import { EditBusinessComponent } from './editBusiness/editBusiness.component';
import { BusinessComponent } from './business.component';
import { BusinessInfoComponent } from './businessInfo/businessInfo.component';




const routes: Routes = [
  { path: 'business', component: BusinessComponent, canActivate: [ AuthGuard ] },
  { path: '', component: BusinessComponent, canActivate: [ AuthGuard ] },
  { path: 'editBusiness', component: EditBusinessComponent, canActivate: [ AuthGuard ] },
  // { path: 'business-businessInfo', component: BusinessInfoComponent, canActivate: [ AuthGuard ] },
  

  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [
  ]
})
export class BusinessRoutingModule { }

